import { render } from "./XmlMapperView.vue?vue&type=template&id=7b505fc3&scoped=true&ts=true"
import script from "./XmlMapperView.vue?vue&type=script&lang=ts"
export * from "./XmlMapperView.vue?vue&type=script&lang=ts"

import "./XmlMapperView.vue?vue&type=style&index=0&id=7b505fc3&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b505fc3"]])

export default __exports__